<template>
    <button class="btn-style btn-layout btn-hover color-1"  @click="onClickHandler">
        <img
            v-show="loading"
            class="loader"
            src="../assets/images/loading-circle.svg"
            alt=""
        />
        <div class="text-style">
            {{ text }}
        </div>
    </button>
</template>

<script>
export default {
    name: "SecondaryButton",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ""
        }
    },
    methods: {
        onClickHandler() {
            this.$emit("clickHandler");
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-layout {
    display: inline-flex;
    padding: 20px 35px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: 0px;
}

.btn-style {
    border-radius: 10px;
    background: var(--primary-ada-blue-100, #007AA3);
    box-shadow: 0px 2px 4px -1px rgba(30, 30, 37, 0.10), 0px 4px 8px 0px rgba(30, 30, 37, 0.16);
    cursor: pointer;
    transition: background-image 100ms linear;

    &:hover {
        background-image: linear-gradient(135deg, #007DA7 0%, #004E69 100%);
        transition: background-image 100ms linear;
    }

    &:active {
        background: var(--primary-ada-blue-100, #004E69);
    }
}

.text-style {
    color: var(--shades-white-ffffff, #FFF);
    text-align: center;
    text-shadow: 0.5px 0.5px 1px 0px rgba(30, 30, 37, 0.30);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 25px;
    letter-spacing: 0.32px;
}
</style>